import React, {useEffect} from 'react'
import gsap from 'gsap'
import ButtonContactGroup from '../ui/ButtonContactGroup'

function Footer() {

    useEffect(()=>{
        gsap.fromTo('.copy',
            { opacity: 0, x: -50, display: 'none' },
            { opacity: 1, x: 0, duration: 1,display:'block', ease: 'power2.out',
            stagger: 0.3,
            scrollTrigger: {
                trigger: '.myFooter',
                start: 'top 100%',
                toggleActions: 'play none none none'
            }
            }
        );
    },[])

  return (
    <footer className='myFooter container-fluid p-3 px-5 bg-light'>
        <div className='row justify-content-between'>
            <div className='col-12 col-md-6 d-flex align-items-center justify-md-content-start justify-md-content-center text-center text-md-start'>
              <small className="copy">©
                <span> 2023 -</span>
                <span id="year">2024</span> Coded and designed by
                <span className="fw-bold "> Mario Di Stefano.</span>
                <span className="d-block d-sm-inline mb-1 mb-sm-0 d-none d-md-block"> All rights reserved.</span>
              </small>
            </div>
             <ButtonContactGroup col={"col-md-2 col d-flex justify-content-center py-2 py-md-0"}/>
        </div>
    </footer>
  )
}

export default Footer